import styles from './Card.module.css';
import { LazyLoadImage } from "react-lazy-load-image-component";

function Card({ item }) {
    return (
        <div className={styles.card}>
            <LazyLoadImage className={styles.image} src={item.img} alt={item.name} title={item.name} loading="lazy"/>
            <p className={styles.name}>{item.name}</p>
            <p className={styles.title}>{item.title}</p>
        </div>
    );
}

export default Card;
